import { useState } from 'react';
import { testimonials } from '@/mocks/comics';
import { Link } from 'react-router-dom';

export default function EditorPick() {
  const [active, setActive] = useState(0);
  const t = testimonials[active];

  return (
    <section className="py-14 md:py-20 bg-background-50 relative overflow-hidden">
      <div className="absolute top-0 left-0 opacity-[0.03] pointer-events-none">
        <svg width="200" height="300" viewBox="0 0 200 300" xmlns="http://m99re.com/2000/svg">
          <path d="M20 280 Q40 230 60 260 Q80 290 70 200 Q60 110 100 150 Q140 190 120 120 Q100 50 150 80 Q200 110 180 40" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-foreground-950"/>
        </svg>
      </div>

      <div className="w-full px-4 md:px-6 relative z-10">
        <div className="max-w-5xl mx-auto">
          <div className="bg-foreground-950 rounded-2xl overflow-hidden flex flex-col lg:flex-row">
            <div className="lg:w-2/5 relative">
              <div className="relative h-80 lg:h-full">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t lg:bg-gradient-to-r from-foreground-950 via-foreground-950/20 to-transparent"></div>
              </div>
            </div>

            <div className="lg:w-3/5 p-8 md:p-10 lg:p-12 flex flex-col justify-center">
              <i className="ri-double-quotes-l text-4xl md:text-5xl text-accent-300 mb-6 block"></i>
              <p className="text-white text-base md:text-lg leading-relaxed mb-8">
                {t.content}
              </p>
              <div className="mb-8">
                <p className="text-white font-medium text-sm">{t.name}</p>
                <p className="text-background-50/40 text-xs mt-1">{t.role}</p>
              </div>

              <div className="flex items-center gap-3 mb-8">
                {testimonials.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setActive(idx)}
                    className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
                      idx === active
                        ? 'bg-primary-500 w-7'
                        : 'bg-background-50/30 hover:bg-background-50/50'
                    }`}
                    aria-label={`查看第${idx + 1}条评价`}
                  ></button>
                ))}
              </div>

              <Link
                to="/category/romance"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-medium px-6 py-3 rounded-full text-sm transition-colors whitespace-nowrap w-fit cursor-pointer"
              >
                探索更多优质漫画
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}